/**
 * Utility function to get or create an element.
 */
export const getOrCreateElement = (
  id: string,
  parent: HTMLElement = document.body,
  tagName: keyof HTMLElementTagNameMap = 'div'
): HTMLElement => {
  let element = document.getElementById(id);
  if (!element) {
    element = document.createElement(tagName);
    element.id = id;
    parent.appendChild(element);
  }
  return element;
};

/**
 * Utility function to remove an element.
 */
export const removeElement = (id: string, parent: HTMLElement = document.body) => {
  const element = document.getElementById(id);
  if (element) parent.removeChild(element);
};
